import { InfoLabel, InfoLabelProps, Link } from "@fluentui/react-components";
import React from "react";

const FilterInfo = (props: Partial<InfoLabelProps>) => (
  <InfoLabel
    style={{ marginLeft: "4px" }}
    info={
      <>
        Select the filtering category by clicking on the dropdown. The available categories are: Case Laws, Tax
        Guidances, and Client Work. When selecting client work also a class should be selected. When selecting tax
        guidances, select at least one tax or keyword.{" "}
      </>
    }
    {...props}
  >
    Info
  </InfoLabel>
);

export default FilterInfo;
